import { render, staticRenderFns } from "./ListReceptionSortVal.vue?vue&type=template&id=13069bfe&scoped=true&"
import script from "./ListReceptionSortVal.vue?vue&type=script&lang=js&"
export * from "./ListReceptionSortVal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13069bfe",
  null
  
)

export default component.exports